import { GameState } from '../game/GameState';

export interface LawDefinition {
  id: string;
  name: string;
  cost: number;
  effect: string;
}

export const laws: LawDefinition[] = [
  { id: 'royal_council_act', name: 'Royal Council Act', cost: 0, effect: '+5 legitimacy baseline' },
  { id: 'expanded_royal_council', name: 'Expanded Royal Council', cost: 70, effect: '+1 advisor capacity, +3 legitimacy' },
  { id: 'war_council_edict', name: 'War Council Edict', cost: 80, effect: '+5 army morale after battles' },
  { id: 'naval_colleges', name: 'Naval Colleges', cost: 75, effect: '+10 port trade value' },
  { id: 'court_of_commerce', name: 'Court of Commerce', cost: 90, effect: '+10% trade income' },
  { id: 'spy_directorate', name: 'Spy Directorate', cost: 65, effect: '+10 espionage success' },
  { id: 'council_of_clergy', name: 'Council of Clergy', cost: 60, effect: '-2 unrest in state religion provinces' },
  { id: 'bureau_of_works', name: 'Bureau of Works', cost: 80, effect: '-1 month construction time minimum' },
];

export class LawManager {
  static readonly instance = new LawManager();

  availableLaws(factionId: string) {
    const active = GameState.instance.requireCampaign().factions[factionId]?.activeLaws ?? [];
    return laws.filter((law) => !active.includes(law.id));
  }

  enactLaw(factionId: string, lawId: string) {
    const campaign = GameState.instance.requireCampaign();
    const faction = campaign.factions[factionId];
    const law = laws.find((entry) => entry.id === lawId);
    if (!faction || !law) return false;
    if (faction.activeLaws.includes(lawId)) {
      GameState.instance.log('Law is already active.', 'warning');
      return false;
    }
    if (faction.treasury < law.cost) {
      GameState.instance.log(`${law.name} requires ${law.cost} gold.`, 'warning');
      return false;
    }
    faction.treasury -= law.cost;
    faction.activeLaws.push(lawId);
    faction.legitimacy = Math.min(100, faction.legitimacy + 2);
    GameState.instance.log(`${law.name} enacted.`, 'success');
    return true;
  }
}
